var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("b-breadcrumb", { attrs: { items: _vm.navigationItems } }),
        _vm._v(" "),
        _c("loading-spinner", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        }),
        _vm._v(" "),
        _c("configuration-custom-id", {
          attrs: { enabled: _vm.shouldPromptForCustomId },
          on: { confirm: _vm.customIdProvided }
        }),
        _vm._v(" "),
        _c(
          "b-container",
          [
            _c(
              "b-form",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.loading,
                    expression: "!loading"
                  }
                ]
              },
              [
                _c(
                  "b-row",
                  { attrs: { "align-v": "center" } },
                  [
                    _c("b-col", { staticClass: "pl-0", attrs: { cols: "7" } }, [
                      _c("h2", [_vm._v(" Edit configuration")])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-row", [
                  _c("p", { staticClass: "mr-2" }, [
                    _vm._v("\n            Updating configuration:\n          ")
                  ]),
                  _c("span", [
                    _vm._v(" " + _vm._s(_vm.applicableConfigurationId))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-v": "start" } },
                  [
                    _c("b-col", { staticClass: "mr-2", attrs: { cols: "1" } }, [
                      _c("label", { attrs: { for: "config-Name" } }, [
                        _vm._v("Name:")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "3" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "config-Name",
                            size: "sm",
                            type: "text",
                            state: _vm.$v.configuration.name.$error
                              ? false
                              : null
                          },
                          model: {
                            value: _vm.configuration.name,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configuration,
                                "name",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "configuration.name"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-invalid-feedback",
                          { attrs: { id: "config-name-invalid-feedback" } },
                          [
                            _vm._v(
                              "\n              Required and must be at least 3 characters\n            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-col", { staticClass: "mr-2", attrs: { cols: "1" } }, [
                      _c("label", { attrs: { for: "config-Description" } }, [
                        _vm._v("Description:")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "config-Description",
                            size: "sm",
                            type: "text",
                            state: _vm.$v.configuration.description.$error
                              ? false
                              : null
                          },
                          model: {
                            value: _vm.configuration.description,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configuration,
                                "description",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "configuration.description"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-invalid-feedback",
                          {
                            attrs: { id: "config-Description-invalid-feedback" }
                          },
                          [
                            _vm._v(
                              "\n              Required and must be at least 3 characters\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _c("label", { attrs: { for: "config-source" } }, [
                        _vm._v("Application Source:")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "5" } },
                      [
                        _c("b-form-select", {
                          attrs: {
                            id: "config-source",
                            options: _vm.appSource,
                            size: "sm"
                          },
                          model: {
                            value: _vm.configuration.selectedAppSource,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configuration,
                                "selectedAppSource",
                                $$v
                              )
                            },
                            expression: "configuration.selectedAppSource"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b-row", { attrs: { "align-v": "start" } }, [
                  _c("h5", [_vm._v("Product ID Alias")])
                ]),
                _vm._v(" "),
                _c("b-row", [
                  _c("p", { staticClass: "mr-2" }, [
                    _vm._v(
                      "\n            Used in processing to identify the product or magazine code.\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { staticClass: "mr-2", attrs: { cols: "1" } }, [
                      _c("label", { attrs: { for: "prodIdAlias" } }, [
                        _vm._v("Alias:")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "2" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "prodIdAlias",
                            size: "sm",
                            type: "text"
                          },
                          model: {
                            value: _vm.configuration.prodAliasId,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configuration,
                                "prodAliasId",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "configuration.prodAliasId"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b-row", { attrs: { "align-v": "start" } }, [
                  _c("h5", [_vm._v("Demo Site Payment Processing")])
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "ml-2",
                            attrs: {
                              id: "demo-in-production-checkbox",
                              plain: ""
                            },
                            model: {
                              value: _vm.configuration.demoClient,
                              callback: function($$v) {
                                _vm.$set(_vm.configuration, "demoClient", $$v)
                              },
                              expression: "configuration.demoClient"
                            }
                          },
                          [
                            _vm._v(
                              "\n              Use this configuration for demo sites.\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.configuration.demoClient,
                        expression: "configuration.demoClient"
                      }
                    ],
                    attrs: { cols: "12" }
                  },
                  [
                    _c("b-col", { attrs: { cols: "12" } }, [
                      _c("span", { staticClass: "warning-message ml-4" }, [
                        _vm._v("Simulated payment processing enabled")
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b-row", { attrs: { "align-v": "start" } }, [
                  _c("h5", [_vm._v("Select Service for Payment Processing")])
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "8" } },
                      [
                        _c("b-form-radio-group", {
                          attrs: {
                            id: "payment-service-radio-group",
                            options: _vm.paymentServices,
                            plain: "",
                            name: "payment-service-selection"
                          },
                          model: {
                            value: _vm.configuration.selectedPaymentService,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configuration,
                                "selectedPaymentService",
                                $$v
                              )
                            },
                            expression: "configuration.selectedPaymentService"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-v": "start" } },
                  [
                    _c("h5", [_vm._v("Credit Cards")]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "ml-2",
                            attrs: { id: "credit-cards-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.credit,
                              callback: function($$v) {
                                _vm.$set(_vm.configuration, "credit", $$v)
                              },
                              expression: "configuration.credit"
                            }
                          },
                          [
                            _vm._v(
                              "\n              Accepted Credit Cards\n            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "ml-4 pl-2",
                            attrs: {
                              state: _vm.$v.configuration.selectedCardTypes
                                .$error
                                ? false
                                : null,
                              "invalid-feedback":
                                "Select at least one type of credit card"
                            }
                          },
                          [
                            _c("b-form-checkbox-group", {
                              attrs: {
                                disabled: !_vm.configuration.credit,
                                plain: "",
                                name: "cardTypes",
                                options: _vm.cardTypes
                              },
                              model: {
                                value: _vm.configuration.selectedCardTypes,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.configuration,
                                    "selectedCardTypes",
                                    $$v
                                  )
                                },
                                expression: "configuration.selectedCardTypes"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "ml-2",
                            attrs: { id: "auth-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.authCallEnabled,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configuration,
                                  "authCallEnabled",
                                  $$v
                                )
                              },
                              expression: "configuration.authCallEnabled"
                            }
                          },
                          [
                            _vm._v(
                              "\n              Perform real-time authorization / settlement\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "ml-4 pl-2",
                                    attrs: {
                                      plain: "",
                                      state: _vm.$v.configuration
                                        .selectedTransactionType.$error
                                        ? false
                                        : null,
                                      "invalid-feedback":
                                        "Select authorization type"
                                    }
                                  },
                                  [
                                    _c("b-form-radio-group", {
                                      attrs: {
                                        id: "auth-radio",
                                        plain: "",
                                        options: _vm.authTypes,
                                        disabled: !_vm.configuration
                                          .authCallEnabled,
                                        name: "auth-selection"
                                      },
                                      model: {
                                        value:
                                          _vm.configuration
                                            .selectedTransactionType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.configuration,
                                            "selectedTransactionType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "configuration.selectedTransactionType"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "ml-2 mb-2",
                            attrs: { id: "avs-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.addressVerification,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configuration,
                                  "addressVerification",
                                  $$v
                                )
                              },
                              expression: "configuration.addressVerification"
                            }
                          },
                          [
                            _vm._v(
                              "\n              Address Verification (AVS)\n            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.configuration.addressVerification,
                            expression: "configuration.addressVerification"
                          }
                        ],
                        attrs: { cols: "12" }
                      },
                      [
                        _c(
                          "b-col",
                          { staticClass: "ml-3 mb-1", attrs: { cols: "12" } },
                          [
                            _vm._v(
                              "\n              Accepted AVS codes:\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "ml-4 pl-2",
                            attrs: {
                              state: _vm.$v.configuration
                                .addressVerificationCodes.$error
                                ? false
                                : null,
                              "invalid-feedback": "Enable at least one AVS code"
                            }
                          },
                          _vm._l(_vm.addressVerificationOptions, function(
                            avsOption
                          ) {
                            return _c(
                              "b-col",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.configuration.addressVerification,
                                    expression:
                                      "configuration.addressVerification"
                                  }
                                ],
                                key: avsOption.code,
                                attrs: { cols: "12" }
                              },
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    key: avsOption.code,
                                    staticClass: "m1-2",
                                    attrs: { value: avsOption.code, plain: "" },
                                    model: {
                                      value:
                                        _vm.configuration
                                          .addressVerificationCodes,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.configuration,
                                          "addressVerificationCodes",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "configuration.addressVerificationCodes"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(avsOption.label) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "ml-2 mb-2",
                            attrs: { id: "expmonth-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.currentMonthExpiration,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configuration,
                                  "currentMonthExpiration",
                                  $$v
                                )
                              },
                              expression: "configuration.currentMonthExpiration"
                            }
                          },
                          [
                            _vm._v(
                              "\n              Accept credit cards having current month and year as expiration date\n            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "ml-2",
                            attrs: { id: "cvv-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.cvv,
                              callback: function($$v) {
                                _vm.$set(_vm.configuration, "cvv", $$v)
                              },
                              expression: "configuration.cvv"
                            }
                          },
                          [_vm._v("\n              Require CVV\n            ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-v": "center" } },
                  [
                    _c("h5", [_vm._v("Support Wrapper")]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "ml-2 mb-2",
                            attrs: { id: "cds-wallet-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.supportWrapper,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configuration,
                                  "supportWrapper",
                                  $$v
                                )
                              },
                              expression: "configuration.supportWrapper"
                            }
                          },
                          [
                            _vm._v(
                              "\n              Enable Wrapper Support\n            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.configuration.supportWrapper,
                            expression: "configuration.supportWrapper"
                          }
                        ],
                        attrs: { cols: "12" }
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "2", align: "right" } },
                              [
                                _c("label", { attrs: { for: "hostedURL" } }, [
                                  _vm._v("Hosted URL:")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "7" } },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "hostedURL",
                                    size: "sm",
                                    type: "text"
                                  },
                                  model: {
                                    value: _vm.configuration.hostedUrl,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.configuration,
                                        "hostedUrl",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "configuration.hostedUrl"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-v": "center" } },
                  [
                    _c("h5", [_vm._v("CDS Wallet")]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "ml-2 mb-2",
                            attrs: { id: "cds-wallet-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.cdsGlobalWallet,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configuration,
                                  "cdsGlobalWallet",
                                  $$v
                                )
                              },
                              expression: "configuration.cdsGlobalWallet"
                            }
                          },
                          [
                            _vm._v(
                              "\n              Wallet as payment option\n            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.configuration.cdsGlobalWallet,
                            expression: "configuration.cdsGlobalWallet"
                          }
                        ],
                        attrs: { cols: "12" }
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "2", align: "right" } },
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: { for: "cdsGlobalWalletCallbackUrl" }
                                  },
                                  [_vm._v("Auth Callback URL:")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "7" } },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "cdsGlobalWalletCallbackUrl",
                                    size: "sm",
                                    type: "text"
                                  },
                                  model: {
                                    value:
                                      _vm.configuration
                                        .cdsGlobalWalletCallbackUrl,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.configuration,
                                        "cdsGlobalWalletCallbackUrl",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression:
                                      "configuration.cdsGlobalWalletCallbackUrl"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b-row", [_c("h4", [_vm._v("Alternate Payments")])]),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-v": "start" } },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "m1-2",
                            attrs: { id: "amazon-pay-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.amazonPay,
                              callback: function($$v) {
                                _vm.$set(_vm.configuration, "amazonPay", $$v)
                              },
                              expression: "configuration.amazonPay"
                            }
                          },
                          [_c("h5", [_vm._v("Enable Amazon Pay")])]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.configuration.amazonPay,
                        expression: "configuration.amazonPay"
                      }
                    ],
                    attrs: { "align-v": "start" }
                  },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-tabs",
                          { attrs: { "content-class": "mt-3" } },
                          [
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  title: "Choose Existing Payment Details"
                                }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showAmazonPaySelect,
                                        expression: "showAmazonPaySelect"
                                      }
                                    ],
                                    attrs: {
                                      "label-for": "amazon-pay-select",
                                      "invalid-feedback":
                                        "A configuration for Amazon Pay is required."
                                    }
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        id: "amazon-pay-select",
                                        options: _vm.amazonPayOptions
                                      },
                                      model: {
                                        value:
                                          _vm.configuration
                                            .amazonPayConfigurationId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.configuration,
                                            "amazonPayConfigurationId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "configuration.amazonPayConfigurationId"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showAmazonPaySelect,
                                        expression: "showAmazonPaySelect"
                                      }
                                    ],
                                    staticClass: "ml-3",
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.editPayment(
                                          "AMAZON",
                                          _vm.configuration
                                            .amazonPayConfigurationId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Edit Publisher Payment Details\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.showAmazonPaySelect,
                                        expression: "!showAmazonPaySelect"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      "\n                  No Amazon Pay configurations available, please\n                  "
                                    ),
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "navigation-links",
                                        attrs: {
                                          disabled: "true",
                                          to: {
                                            name: "alternativePayments",
                                            params: { clientId: _vm.clientId }
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    create one\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                  .\n                "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              { attrs: { title: "Enter Payment Details" } },
                              [
                                _c("edit-alternative-payment-item", {
                                  attrs: {
                                    "payment-type": "AMAZON",
                                    "configuration-id": _vm.configurationId
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-v": "start" } },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "m1-2",
                            attrs: { id: "apple-pay-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.applePay,
                              callback: function($$v) {
                                _vm.$set(_vm.configuration, "applePay", $$v)
                              },
                              expression: "configuration.applePay"
                            }
                          },
                          [_c("h5", [_vm._v("Enable Apple Pay")])]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.configuration.applePay,
                        expression: "configuration.applePay"
                      }
                    ],
                    attrs: { "align-v": "start" }
                  },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-tabs",
                          { attrs: { "content-class": "mt-3" } },
                          [
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  title: "Choose Existing Payment Details"
                                }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showApplePaySelect,
                                        expression: "showApplePaySelect"
                                      }
                                    ],
                                    attrs: {
                                      "label-for": "apple-pay-select",
                                      "invalid-feedback":
                                        "A configuration for Apple Pay is required."
                                    }
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        id: "apple-pay-select",
                                        options: _vm.applePayOptions
                                      },
                                      model: {
                                        value:
                                          _vm.configuration
                                            .applePayConfigurationId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.configuration,
                                            "applePayConfigurationId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "configuration.applePayConfigurationId"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showApplePaySelect,
                                        expression: "showApplePaySelect"
                                      }
                                    ],
                                    staticClass: "ml-3",
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.editPayment(
                                          "APPLE",
                                          _vm.configuration
                                            .applePayConfigurationId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Edit Publisher Payment Details\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.showApplePaySelect,
                                        expression: "!showApplePaySelect"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      "\n                  No Apple Pay configurations availabae, please\n                  "
                                    ),
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "navigation-links",
                                        attrs: {
                                          disabled: "true",
                                          to: {
                                            name: "alternativePayments",
                                            params: { clientId: _vm.clientId }
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    create one\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                  .\n                "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              { attrs: { title: "Enter Payment Details" } },
                              [
                                _c("edit-alternative-payment-item", {
                                  attrs: {
                                    "payment-type": "APPLE",
                                    "configuration-id": _vm.configurationId,
                                    "alternative-payment":
                                      _vm.configuration.applePayConfiguration
                                  },
                                  on: {
                                    "update:alternativePayment": function(
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.configuration,
                                        "applePayConfiguration",
                                        $event
                                      )
                                    },
                                    "update:alternative-payment": function(
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.configuration,
                                        "applePayConfiguration",
                                        $event
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-v": "start" } },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "m1-2",
                            attrs: { id: "pay-pal-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.payPal,
                              callback: function($$v) {
                                _vm.$set(_vm.configuration, "payPal", $$v)
                              },
                              expression: "configuration.payPal"
                            }
                          },
                          [_c("h5", [_vm._v("Enable PayPal")])]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.configuration.payPal,
                        expression: "configuration.payPal"
                      }
                    ],
                    attrs: { "align-v": "start" }
                  },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-tabs",
                          { attrs: { "content-class": "mt-3" } },
                          [
                            _c(
                              "b-tab",
                              {
                                attrs: {
                                  title: "Choose Existing Payment Details"
                                }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showPayPalSelect,
                                        expression: "showPayPalSelect"
                                      }
                                    ],
                                    attrs: {
                                      "label-for": "pay-pal-select",
                                      "invalid-feedback":
                                        "A configuration for PayPal is required."
                                    }
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        id: "payment-type-select",
                                        options: _vm.payPalOptions
                                      },
                                      model: {
                                        value:
                                          _vm.configuration
                                            .payPalConfigurationId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.configuration,
                                            "payPalConfigurationId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "configuration.payPalConfigurationId"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.showPayPalSelect,
                                        expression: "!showPayPalSelect"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      "\n                  No PayPal configurations available, please\n                  "
                                    ),
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "navigation-links",
                                        attrs: {
                                          disabled: "true",
                                          to: {
                                            name: "alternativePayments",
                                            params: { clientId: _vm.clientId }
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    create one\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                  .\n                "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tab",
                              { attrs: { title: "Enter Payment Details" } },
                              [
                                _c("edit-alternative-payment-item", {
                                  attrs: {
                                    "payment-type": "PAYPAL",
                                    "configuration-id": _vm.configurationId,
                                    "load-payment": !_vm.hasOwnPayPalDetails
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showPayPalSelect,
                                expression: "showPayPalSelect"
                              }
                            ],
                            staticClass: "ml-3",
                            attrs: { variant: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.editPayment(
                                  "PAYPAL",
                                  _vm.configuration.payPalConfigurationId
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              Edit Publisher Payment Details\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-row",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tokenizationForAltPayments,
                        expression: "tokenizationForAltPayments"
                      }
                    ],
                    attrs: { "align-v": "center" }
                  },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "5" } },
                      [
                        _c("h5", [_vm._v("Alternative Payments Tokenization")]),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "ml-4 pl-2",
                            attrs: {
                              plain: "",
                              state: _vm.$v.configuration
                                .selectedTokenizationStage.$error
                                ? false
                                : null,
                              "invalid-feedback": "Select tokenize stage"
                            }
                          },
                          [
                            _c("b-form-radio-group", {
                              attrs: {
                                id: "tokenize-radio",
                                plain: "",
                                options: _vm.tokenizeStages,
                                name: "tokenize-selection"
                              },
                              model: {
                                value:
                                  _vm.configuration.selectedTokenizationStage,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.configuration,
                                    "selectedTokenizationStage",
                                    $$v
                                  )
                                },
                                expression:
                                  "configuration.selectedTokenizationStage"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "5" } },
                      [
                        _c("h5", [_vm._v("Alternative Payments Buttons Size")]),
                        _vm._v(" "),
                        _c("b-form-select", {
                          staticClass: "ml-4 pl-2",
                          attrs: { options: _vm.buttonsSizes, size: "sm" },
                          model: {
                            value: _vm.configuration.selectedButtonsSize,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configuration,
                                "selectedButtonsSize",
                                $$v
                              )
                            },
                            expression: "configuration.selectedButtonsSize"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "2" } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-v": "center" } },
                  [
                    _c("h5", [_vm._v("reCAPTCHA")]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "ml-2 mb-2",
                            attrs: { id: "recaptcha-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.recaptcha,
                              callback: function($$v) {
                                _vm.$set(_vm.configuration, "recaptcha", $$v)
                              },
                              expression: "configuration.recaptcha"
                            }
                          },
                          [
                            _vm._v(
                              "\n              Enable reCAPTCHA\n            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.configuration.recaptcha,
                            expression: "configuration.recaptcha"
                          }
                        ],
                        attrs: { cols: "12" }
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "2", align: "right" } },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "config-Description" } },
                                  [_vm._v("Site Key:")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "7" } },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "config-RecaptchaSiteKey",
                                    placeholder: "Site Key",
                                    size: "sm",
                                    type: "text"
                                  },
                                  model: {
                                    value: _vm.configuration.recaptchaSiteKey,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.configuration,
                                        "recaptchaSiteKey",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "configuration.recaptchaSiteKey"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "2", align: "right" } },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "config-ScoreThreshold" } },
                                  [_vm._v("Score Threshold:")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "3" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.recaptchaScores,
                                    size: "sm"
                                  },
                                  model: {
                                    value:
                                      _vm.configuration
                                        .selectedRecaptchaScoreThreshold,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.configuration,
                                        "selectedRecaptchaScoreThreshold",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configuration.selectedRecaptchaScoreThreshold"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", {
                              attrs: { cols: "2", align: "right" }
                            }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "10" } },
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: {
                                      id: "data-collection-only-checkbox",
                                      plain: ""
                                    },
                                    model: {
                                      value:
                                        _vm.configuration
                                          .recaptchaDataCollection,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.configuration,
                                          "recaptchaDataCollection",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "configuration.recaptchaDataCollection"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Data collection only\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.configuration.recaptchaDataCollection,
                                expression:
                                  "configuration.recaptchaDataCollection"
                              }
                            ],
                            attrs: { cols: "12" }
                          },
                          [
                            _c("b-col", { attrs: { cols: "2" } }),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "10" } }, [
                              _c("span", { staticClass: "warning-message" }, [
                                _vm._v(
                                  "Score returned by reCAPTCHA will not be evaluated."
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.configuration.recaptcha,
                                expression: "!configuration.recaptcha"
                              }
                            ],
                            staticClass: "ml-2 mb-2",
                            attrs: {
                              id: "recaptcha-disable-checkbox",
                              plain: ""
                            },
                            model: {
                              value: _vm.configuration.disableRecaptcha,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configuration,
                                  "disableRecaptcha",
                                  $$v
                                )
                              },
                              expression: "configuration.disableRecaptcha"
                            }
                          },
                          [
                            _vm._v(
                              "\n              Disable reCAPTCHA\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-v": "center" } },
                  [
                    _c("h5", [_vm._v("Bill Me Later")]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "ml-2",
                            attrs: { id: "billmelater-checkbox", plain: "" },
                            model: {
                              value: _vm.configuration.billMeLater,
                              callback: function($$v) {
                                _vm.$set(_vm.configuration, "billMeLater", $$v)
                              },
                              expression: "configuration.billMeLater"
                            }
                          },
                          [
                            _vm._v(
                              "\n              Allow Bill Me Later? (credit orders)\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b-row", { attrs: { "align-v": "start" } }, [
                  _c("h5", [_vm._v("Client Code")])
                ]),
                _vm._v(" "),
                _c("b-row", [
                  _c("p", { staticClass: "mr-2" }, [
                    _vm._v(
                      "\n            Used only for backwards compatibility with widgets that do not yet send a Configuration ID.\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { staticClass: "mr-2", attrs: { cols: "1" } }, [
                      _c("label", { attrs: { for: "clientId" } }, [
                        _vm._v("Code:")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "3" } },
                      [
                        _c("b-form-input", {
                          attrs: { id: "clientId", size: "sm", type: "text" },
                          model: {
                            value: _vm.configuration.clientCode,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.configuration,
                                "clientCode",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "configuration.clientCode"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("paymentwidget-preview", {
                      attrs: {
                        "pw-config-number": _vm.applicableConfigurationId
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "box" }, [
                  _c("div", { staticClass: "success-message mt-2 pt-2" }, [
                    _c(
                      "div",
                      { staticClass: "child-div-success-message" },
                      [
                        _c(
                          "b-alert",
                          {
                            staticClass: "ml-5 mr-5 pt-2 pb-2",
                            attrs: {
                              color: "success",
                              variant: "success",
                              show: _vm.configSavedSuccessfully
                            }
                          },
                          [
                            _vm._v(
                              "\n                Configuration saved successfully\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "button-action-ct button-align-center mt-2 pt-2"
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-3",
                          attrs: {
                            variant: "primary",
                            disabled:
                              _vm.configSavedSuccessfully ||
                              _vm.$v.configuration.$error
                          },
                          on: { click: _vm.saveConfig }
                        },
                        [_vm._v("\n              Save\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.modal-center",
                              modifiers: { "modal-center": true }
                            }
                          ],
                          staticClass: "ml-3",
                          attrs: { variant: "secondary" },
                          on: { click: _vm.showPreview }
                        },
                        [_vm._v("\n              Preview\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-3",
                          attrs: { variant: "secondary" },
                          on: { click: _vm.resetConfig }
                        },
                        [_vm._v("\n              Cancel\n            ")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }